<template lang="pug">
.st-tooltip.animate__animated.animate__fadeIn(
  v-show="show",
  :class="{ left: displaySide !== 'right', show: show }",
  @mouseover="$emit('overTooltip')",
  @mouseleave="$emit('leaveTooltip'); stopVideo()",
  ref="tooltip"
)
  font-awesome-icon.tooltip-closeIcon(
    icon="times",
    size="2x",
    :style="{ color: 'white' }",
    @click="$emit('closeTooltip')"
  )
  h6.tooltip-subtitle {{ subtitle }}
  h4.tooltip-title {{ title }}
  span.tooltip-content(v-html="desc")
  .tooltip-icons
    img.icon(
      v-if="media.pano",
      src="@/assets/images/explore-icon-720.png",
      @click="$emit('clickMedia', 'pano')"
    )
    img.icon(
      v-if="media.vr",
      src="@/assets/images/explore-icon-360.png",
      @click="$emit('clickMedia', 'vr')"
    )
    img.icon(
      v-if="media.video",
      src="@/assets/images/explore-icon-play.png",
      @click="$emit('clickMedia', 'video')"
    )
    font-awesome-icon.icon(
      v-if="media.link",
      :icon="'link'",
      size="2x",
      @click="$emit('clickMedia', 'link')"
    )
  .tooltip-video(v-if="media.embedVideo")
    iframe(
      :src="media.embedVideo",
      width="100%",
      height="100%",
      frameborder="0",
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen
    )
</template>

<script>
import $ from "jquery";
export default {
  name: "Tooltip",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Title"
    },
    subtitle: {
      type: String,
      default: "Subtitle"
    },
    desc: {
      type: String,
      default: "Desc"
    },
    media: {
      type: Object,
      default: function () {
        return {
          pano: null,
          vr: null,
          video: null,
          link: null,
          embedVideo: null
        };
      }
    }
  },
  data() {
    return {
      displaySide: "left",
      windowWidth: window.innerWidth
    };
  },
  methods: {
    setPosition(mouseClickEvent) {
      this.setWidth();
      let tooltip = this.$refs.tooltip;
      // console.log(this.$refs)
      // console.log(tooltip);
      let browser = (
        this.$store.state.browser.name.replace(/ /g, "_") || ""
      ).toLowerCase();
      if (browser.includes("edge") || browser.includes("ie")) {
        tooltip.scrollTop = 0;
      } else {
        tooltip.scrollTo(0, 0);
      }

      if (this.windowWidth <= 768) return;

      let midWidth = Math.floor(window.innerWidth / 2);
      let mouseX = mouseClickEvent.x;
      let mouseY = mouseClickEvent.y;
      let finalX;
      this.displaySide = mouseX > midWidth ? "left" : "right";

      let finalY = mouseY + 150;

      if (mouseY > window.innerHeight / 2) {
        finalY = finalY - (window.innerHeight / 3 )  +100
      }

      if (finalY + tooltip.offsetHeight > window.innerHeight+300) {
        finalY = window.innerHeight - tooltip.offsetHeight/5;
      }

      if (finalY < 0) {
        finalY = 10;
      }

      if(this.$route.path.includes('explore')){
        if(finalY + tooltip.offsetHeight > window.innerHeight){
          finalY = 50;
        }
      }

      tooltip.style.top = finalY + "px";

      if (this.displaySide == "left") {
        finalX = mouseX - window.innerWidth * 0.5;
        tooltip.style.left = finalX + "px";
      } else {
        tooltip.style.left = mouseX - 10 + "px";
      }
    },
    stopVideo() {
      if (this.media.embedVideo) {
        document.querySelector(
          ".st-tooltip .tooltip-video > iframe"
        ).src = this.media.embedVideo;
      }
    },
    setWidth() {
      this.windowWidth = window.innerWidth;
    }
  },
  mounted() {
    this.setPosition({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
    window.addEventListener("resize", this.setPosition);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setPosition);
    // window.addEventListener("resize", this.setPosition);
  }
};
</script>

<style lang="sass">
@import "@/assets/css/mixins.scss"
.tooltip-fade-enter-active, .tooltip-fade-leave-active
  transition: opacity .5s

.tooltip-fade-enter, .tooltip-fade-leave-to /* .fade-leave-active below version 2.1.8 */
  opacity: 0

.st-tooltip
  width: 45vw
  max-width: 600px
  max-height: 95vh
  overflow-y: scroll
  z-index: 66
  color: white
  padding: 28px 36px
  background-color: #2B1500
  border-radius: 5px
  border-top: solid 10px #2B1500
  border-bottom: solid 10px #2B1500
  box-shadow: 0px 0px 30px -10px rgba(black,0.5)
  position: absolute
  opacity: 0
  transition: 0.5s
  &.show
    opacity: 1
  .tooltip-closeIcon
    display: initial
    cursor: pointer
    position: absolute
    right: 15px
    top: 10px
  .tooltip-title
    font-weight: bold
    width: fit-content
    background-color: #2B1500
    font-size: 32px
    box-sizing: content-box
    z-index: 1
    padding-right: 5px
    z-index: -1
  .tooltip-content
    line-height: 1.8
  .tooltip-icons
    margin-top: 10px
    .icon
      width: 35px
      margin-right: 10px
      &:hover
        cursor: pointer
  .tooltip-video > iframe
    width: 100%
    min-height: 400px
  @include for_breakpoint(mobile)
    border-radius: 0px
    // padding: 100px !important

@include for_breakpoint(mobile)
  .st-tooltip
    position: fixed !important
    padding: 12px 18px 24PX 18px
    // padding: 10px
    bottom: 0
    left: 0
    right: unset
    width: 100vw
    max-width: none
    max-height: 30vh !important
    overflow: hidden auto
    .tooltip-title
      font-size: 24px
      &::before
        top: 68px
    .tooltip-subtitle
      max-width: 90%
      line-height: 1.5
    .tooltip-closeIcon
      display: initial
</style>
